/**
 * Shared modal shell for JobMatchExplainer — dashboard, jobs table, job cards.
 */
import React from 'react';

import type { MatchBreakdown } from './JobMatchExplainer';
import JobMatchExplainer from './JobMatchExplainer';

export interface JobMatchExplainerModalProps {
  open: boolean;
  jobTitle: string;
  company: string;
  breakdown: MatchBreakdown;
  onClose: () => void;
  onOptimize?: () => void;
}

const JobMatchExplainerModal: React.FC<JobMatchExplainerModalProps> = ({
  open,
  jobTitle,
  company,
  breakdown,
  onClose,
  onOptimize,
}) => {
  if (!open) return null;

  return (
    <div
      className="ds-match-explainer-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="ds-match-explainer-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="job-match-explainer-title"
      >
        <JobMatchExplainer
          visible
          jobTitle={jobTitle}
          company={company}
          breakdown={breakdown}
          onClose={onClose}
          onOptimize={onOptimize}
        />
      </div>
    </div>
  );
};

export default React.memo(JobMatchExplainerModal);
